const shadowHost = document.getElementById('AppRoot');
shadowHost.attachShadow({ mode: 'open' });
